var firebase = require("firebase/app");
import router from '@/router'

export default {
	state: {
		user: '',
	},
	mutations: {
		setUser(state, payload) {
			state.user = payload

		},
	},
	actions: {
		loginUser({ commit, dispatch }, payload) {
			commit('SET_LOADED', false)
			firebase.auth().signInWithEmailAndPassword(payload.email, payload.pass)
				.then(res => {
					commit('setUser', { email: res.user.email, uid: res.user.uid })
					commit('SET_LOADED', true)
					router.push({ name: 'AdminDashboard' })
				})
				.catch(err => {
					console.log(err);
					commit('SET_LOADED', true)
					commit('SET_SHOWSNACK', true)
				})
		},
		checkUser({ commit }, payload) {
			if (payload != null) {
				commit('setUser', { email: payload.email, uid: payload.uid })
			} else {
				commit('setUser', null)
			}
		},
		logOff({ commit }) {
			firebase.auth().signOut()
			commit('setUser', null)
			router.push({ name: 'Login' })
		},
	},
	getters: {
		logonUser(state) {
			if (state.user === null || state.user === '' || state.user === undefined) {
				return false
			} else {
				return true
			}
		}
	}
}